/**
* Google Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Google Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
( function( app ) {
  const COMPONENT = {
    defaultCoordinates: {
      lat: '38.966829',
      lng: '-95.2360857',
    },
    className: 'google-map',
    address: $( '.google-map__single-address' ).text(),
    mapPinIcon: 'M16 0c-6.39 0-11.589 5.199-11.589 11.589 0 7.93 10.371 19.573 10.813 20.065 0.415 0.462 1.139 0.461 1.553 0 0.442-0.492 10.813-12.134 10.813-20.065-0-6.39-5.199-11.589-11.589-11.589zM16 17.42c-3.215 0-5.831-2.616-5.831-5.831s2.616-5.831 5.831-5.831 5.831 2.616 5.831 5.831-2.616 5.831-5.831 5.831z',
    pinColor: '#797979',
    locationName: site_info.name,

    selector: function() {
      return '.' + this.className;
    },

    mapElementTarget: function() {
      return '#' + $( '.google-map' ).attr( 'id' );
    },

    mapElementId: function() {
      return $( '.google-map' ).attr( 'id' );
    },

    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let loaded = false;

      const addresses = [];
      if ( $( '.google-map__addresses' ).length ) {
        $( '.google-map__address' ).each( function() {
          addresses.push( {
            address: $( this ).find( '.address-address' ).text(),
            title: $( this ).find( '.address-title' ).text(),
            target: $( this ).find( '.address-target' ).text(),
            link: $( this ).find( '.address-link' ).text(),
            location: $( this ).find( '.address-location' ).text(),
            infowindow: $( this ).find( '.address-infowindow' ).html(),
            pinColor: $( this ).find( '.address-pin-color' ).text(),
          } );
        } );
      }

      console.log( addresses );

      const singleAddress = $( '.google-map__single-address' ).find( '.address-address' ).text();
      const addressLink = $( '.google-map__single-address' ).find( '.address-link' ).text();
      const infowindowContent = $( '.google-map__single-address' ).find( '.address-infowindow' ).html();

      console.log( singleAddress );

      const _this = this;
      // map
      let map;
      const markers = [];
      const bounds = new google.maps.LatLngBounds();
      const address = _this.address;
      let zoom;

      if ( $( '.google-map__hide .zoom' ).length > 0 ) {
        zoom = parseInt( $( '.google-map__hide .zoom' ).text() );
      } else {
        zoom = 10;
      }

      function initializeMap() {
        const centerCoordinates = new google.maps.LatLng( '38.966829', '-95.2360857' );
        const mapOptions = {
          disableDefaultUI: true,
          zoomControl: true,
          zoom: zoom,
          scrollwheel: false,
          scaleControl: false,
          draggable: true,
          // center: centerCoordinates,
          styles: [{'featureType': 'water', 'elementType': 'geometry', 'stylers': [{'color': '#e9e9e9'}, {'lightness': 17}]}, {'featureType': 'landscape', 'elementType': 'geometry', 'stylers': [{'color': '#f5f5f5'}, {'lightness': 20}]}, {'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [{'color': '#ffffff'}, {'lightness': 17}]}, {'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [{'color': '#ffffff'}, {'lightness': 29}, {'weight': 0.2}]}, {'featureType': 'road.arterial', 'elementType': 'geometry', 'stylers': [{'color': '#ffffff'}, {'lightness': 18}]}, {'featureType': 'road.local', 'elementType': 'geometry', 'stylers': [{'color': '#ffffff'}, {'lightness': 16}]}, {'featureType': 'poi', 'elementType': 'geometry', 'stylers': [{'color': '#f5f5f5'}, {'lightness': 21}]}, {'featureType': 'poi.park', 'elementType': 'geometry', 'stylers': [{'color': '#dedede'}, {'lightness': 21}]}, {'elementType': 'labels.text.stroke', 'stylers': [{'visibility': 'on'}, {'color': '#ffffff'}, {'lightness': 16}]}, {'elementType': 'labels.text.fill', 'stylers': [{'saturation': 36}, {'color': '#333333'}, {'lightness': 40}]}, {'elementType': 'labels.icon', 'stylers': [{'visibility': 'off'}]}, {'featureType': 'transit', 'elementType': 'geometry', 'stylers': [{'color': '#f2f2f2'}, {'lightness': 19}]}, {'featureType': 'administrative', 'elementType': 'geometry.fill', 'stylers': [{'color': '#fefefe'}, {'lightness': 20}]}, {'featureType': 'administrative', 'elementType': 'geometry.stroke', 'stylers': [{'color': '#fefefe'}, {'lightness': 17}, {'weight': 1.2}]}],
        };
        map = new google.maps.Map( document.getElementById( _this.mapElementId() ), mapOptions );
        updateMapMarkers();
      }

      if ( typeof $( _this.mapElementId ) !== 'undefined' && $( _this.mapElementTarget() ).length > 0 ) {
        // google.maps.event.addDomListener(window, 'load', initializeMap);
      }

      const updateMapMarkers = function() {
        const geocoder = new google.maps.Geocoder();

        if ( $( addresses ).length > 0 && !loaded ) { // If multiple addresses
          loaded = true;
          console.log( _this.pinColor );
          $.each( addresses, function( index, val ) {
            const icon = {
              path: _this.mapPinIcon,
              fillColor: _this.pinColor,
              fillOpacity: 1,
              anchor: new google.maps.Point( 12, 16 ),
              strokeWeight: 0,
              scale: 1.25,
            };

            let centerMap;

            geocoder.geocode( {
              'address': val.address,
            },

            function( results, status ) {
              if ( status === google.maps.GeocoderStatus.OK ) {
                const marker = new google.maps.Marker( {
                  position: results[0].geometry.location,
                  map: map,
                  icon: icon,
                } );
                const offsetLat = -0.02;
                const offsetLng = -0.02;
                // map.setCenter(new google.maps.LatLng((map.getCenter().lat() + offsetLat) , (map.getCenter().lng() + offsetLng)));
                map.setCenter( results[0].geometry.location );

                bounds.extend( results[0].geometry.location );

                const contentString = '<div class="google-map__infowindow-content">'+ val.infowindow + '</div>';

                const infowindow = new google.maps.InfoWindow( {
                  content: contentString,
                } );

                marker.addListener( 'click', function() {
                  infowindow.open( map, marker );
                } );

                google.maps.event.addListener( infowindow, 'closeclick', function() {
                  map.fitBounds( bounds );
                } );

                map.fitBounds( bounds );
              }
            } );
          } ); // endforeach
        } else { // If just one address
          console.log( _this.pinColor );
          const icon = {
            path: _this.mapPinIcon,
            fillOpacity: 1,
            fillColor: _this.pinColor,
            anchor: new google.maps.Point( 12, 16 ),
            strokeWeight: 0,
            scale: 1.5,
          };

          let centerMap;

          geocoder.geocode( {
            'address': singleAddress,
          },

          function( results, status ) {
            if ( status === google.maps.GeocoderStatus.OK ) {
              const marker = new google.maps.Marker( {
                position: results[0].geometry.location,
                map: map,
                icon: icon,
                url: addressLink,
              } );
              map.setCenter( results[0].geometry.location );

              const contentString = '<div class="google-map__infowindow-content">'+ infowindowContent + '</div>';

              const infowindow = new google.maps.InfoWindow( {
                content: contentString,
              } );

              marker.addListener( 'click', function() {
                infowindow.open( map, marker );
              } );
            }
          } );
        }
      };

      initializeMap();
    },

    finalize: function() {
      const _this = this;
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'google-map', COMPONENT );
} )( app );
